import React, { useEffect, useState } from "react";

import * as C from "./Home.styles.js";

import InstagramIcon from "../../assets/icons/InstagramIcon.svg";
import WhatsAppIcon from "../../assets/icons/WhatsAppIcon.svg";

import Header from "../../components/Header/Header.jsx";
import Address from "../../components/Address/Address.jsx";
import Card from "../../components/Card/Card.jsx";

import { pizzas } from "../../utils/formatters.js";
import Footer from "../../components/Footer/Footer.jsx";
import Order from "../../components/Order/Order.jsx";
import Bag from "../../components/Bag/Bag.jsx";
import FinalForm from "../../components/FinalForm/FinalForm.jsx";

import Coca from "../../assets/images/CocaImage.png";
import Kitubaina from "../../assets/images/KitubainaImage.png";

const Home = () => {
	const [openBag, setOpenBag] = useState(false);
	const [openFinalForm, setOpenFinalForm] = useState(false);
	const [categoriaSelecionada, setCategoriaSelecionada] = useState("all");
	const [showOrderDetailsPopup, setShowOrderDetailsPopup] = useState(false);
	const [currentItem, setCurrentItem] = useState(null);

	const [orderData, setOrderData] = useState();

	const [currentOrder, setCurrentOrder] = useState({
		name: "Pedido Atual",
		items: [],
		refris: []
	});

	const [pizzasFiltradas, setPizzasFiltradas] = useState({
		combo: pizzas.combos,
		meioMetro: pizzas.meioMetro,
		tradicionais: pizzas.tradicionais,
		especiais: pizzas.especiais,
		doces: pizzas.doces
	});

	useEffect(() => {
		const filtro =
			categoriaSelecionada === "all"
				? { combo: pizzas.combos, meioMetro: pizzas.meioMetro, tradicionais: pizzas.tradicionais, especiais: pizzas.especiais, doces: pizzas.doces }
				: { [categoriaSelecionada]: pizzas[categoriaSelecionada] || [] };

		setPizzasFiltradas(filtro);
	}, [categoriaSelecionada]);

	const handleOrder = (pizza) => {
		setCurrentItem(pizza);
		setShowOrderDetailsPopup(true);
	};

	const handleOrderSave = (details) => {
		setCurrentOrder((prevOrder) => ({
			...prevOrder,
			items: [...prevOrder.items, details],
		}));
		setShowOrderDetailsPopup(false);
	};

	const handleAdd = (name, valor) => {
		setCurrentOrder((prevOrder) => {
			const existingRefri = prevOrder.refris.find((item) => item.name === name);
			if (existingRefri) {
				return {
					...prevOrder,
					refris: prevOrder.refris.map((item) =>
						item.name === name
							? { ...item, quantity: item.quantity + 1 }
							: item
					),
				};
			} else {
				return {
					...prevOrder,
					refris: [...prevOrder.refris, { name, price: valor, quantity: 1 }],
				};
			}
		});
	};

	const handleRemove = (name) => {
		setCurrentOrder((prevOrder) => {
			const existingRefri = prevOrder.refris.find((item) => item.name === name);

			if (existingRefri && existingRefri.quantity > 1) {
				return {
					...prevOrder,
					refris: prevOrder.refris.map((item) =>
						item.name === name
							? { ...item, quantity: item.quantity - 1 }
							: item
					),
				};
			} else {
				return {
					...prevOrder,
					refris: prevOrder.refris.filter((item) => item.name !== name),
				};
			}
		});
	};

	const sendWhatsappMessage = () => {
		const totalSemEntrega = currentOrder.items.reduce((total, item) => {
			const totalAdicionais = item.extras.reduce((sum, extra) => sum + extra.valor, 0);
			return total + item.price + totalAdicionais;
		}, 0) + currentOrder.refris.reduce((totalRefris, refri) => totalRefris + refri.price * refri.quantity, 0);

		const pizzas = currentOrder.items
			.map((item) => {
				if (item.tipo && item.tipo === "combo") {
					return `*Combo de Pizzas*\n
- *Pizza G:* ${item.pizza.pizza1G}${item.pizza.pizza2G !== "" ? `\n- *Pizza G:* ${item.pizza.pizza2G}` : ""}
- *Pizza P:* ${item.pizza.pizza1P}
- *Observações:* ${item.observations}
- *Valor unitário*: R$ ${item.price},00 
- Subtotal do item: R$ ${item.price},00`;
				}

				if (item.tipo && item.tipo === "meio metro") {
					const totalAdicionais = item.extras.reduce((sum, extra) => sum + extra.valor, 0);
					const subtotal = item.price + totalAdicionais;

					return `*Pizza Meio Metro*\n
- *Sabores*: ${item.pizza}
- *Borda:* ${item.pizzaBorder || "Nenhuma"}
${item.extras.length > 0
							? `- *Adicionais:*\n${item.extras
								.map((extra) => `  - ${extra.nome}: R$ ${extra.valor},00`)
								.join("\n")}`
							: "- *Adicionais: Nenhum*"
						}  
- *Observações:* ${item.observations || "Nenhuma"}
- *Valor unitário*: R$ ${item.price},00
- *Subtotal do item*: R$ ${subtotal},00`;
				}

				if (item.tipo && item.tipo === "familia") {
					const totalAdicionais = item.extras.reduce((sum, extra) => sum + extra.valor, 0);
					const subtotal = item.price + totalAdicionais;

					return `*Pizza Família*\n
- *Sabores*: ${item.pizza}
- *Borda:* ${item.pizzaBorder || "Nenhuma"}
${item.extras.length > 0
							? `- *Adicionais:*\n${item.extras
								.map((extra) => `  - ${extra.nome}: R$ ${extra.valor},00`)
								.join("\n")}`
							: "- *Adicionais: Nenhum*"
						}  
- *Observações:* ${item.observations || "Nenhuma"}
- *Valor unitário*: R$ ${item.price},00
- *Subtotal do item*: R$ ${subtotal},00`;
				}

				const totalAdicionais = item.extras.reduce((sum, extra) => sum + extra.valor, 0);
				const subtotal = item.price + totalAdicionais;
				return `*Pizza ${item.size} - ${item.portion === "Inteira"
					? item.pizza
					: `Meia ${item.pizza} e Meia ${item.additionalPizza}`
					}*
- *Valor unitário*: R$ ${item.price},00  
- *Borda:* ${item.pizzaBorder || "Nenhuma"}
${item.extras.length > 0
						? `- *Adicionais:*\n${item.extras
							.map((extra) => `  - ${extra.nome}: R$ ${extra.valor},00`)
							.join("\n")}`
						: "- *Adicionais: Nenhum*"
					}  
- *Observações: ${item.observations || "Nenhuma"}*  
- *Subtotal do item*: R$ ${subtotal},00`;
			})
			.join("\n\n");

		const refris = currentOrder.refris.length > 0
			? currentOrder.refris.map((item) => {
				return `*Refri ${item.name} (R$ ${item.price},00)*
- *Quantidade*: ${item.quantity}
- *Subtotal do item*: R$ ${item.quantity * item.price},00`;
			})
			: "";

		const message = `Olá, gostaria de fazer um pedido de pizza!

Meu nome é *${orderData.clientName}*
			
*Detalhes do Pedido:*
			
${pizzas}

${refris}
			
*Valor total sem entrega:* R$ ${totalSemEntrega},00
			
*Tipo de entrega:* ${orderData.isDelivery.charAt(0).toUpperCase() + orderData.isDelivery.slice(1)}  
${orderData.isDelivery === "entrega"
				? `- Endereço: ${orderData.clientAddress}`
				: "- Endereço para retirada: Avenida Marechal Dutra, nº 346 - Centro Rondonópolis - MT"
			}
			
*Forma de pagamento:* ${orderData.paymentMethod.charAt(0).toUpperCase() + orderData.paymentMethod.slice(1)}.
			
${orderData.isDelivery === "entrega" ? "- Taxa de entrega: O vendedor responderá em breve com o valor da entrega e o novo *Total final* do seu pedido." : ""}
			
Aguardo a confirmação do pedido.`;

		const link = `https://wa.me/5566999380118?text=${encodeURIComponent(message)}`;
		window.location.href = link;
	}

	return (
		<C.HomeContainer>
			<C.HomeContent>
				{/* Pop-up do formulário final do pedido */}
				{openFinalForm &&
					<FinalForm
						onClose={() => setOpenFinalForm(false)}
						isOpen={openFinalForm}
						setOrderData={setOrderData}
						sendWhatsappMessage={() => sendWhatsappMessage()}
					/>
				}
				{/* Pop-up de detalhes do pedido */}
				{showOrderDetailsPopup && (
					<Order
						pizza={currentItem}
						onClose={() => setShowOrderDetailsPopup(false)}
						onSave={handleOrderSave}
						isOpen={showOrderDetailsPopup}
						pizzas={pizzas}
					/>
				)}
				{/* Pop-up da sacola de pedido */}
				<Bag setOpenFinalForm={setOpenFinalForm} currentOrder={currentOrder} setCurrentOrder={setCurrentOrder} quantidade={currentOrder.items.length + currentOrder.refris.length} isOpen={openBag} onClose={() => setOpenBag(!openBag)} />

				{/* Header e Endereço */}
				<Header />
				<Address />

				{/* Links para redes sociais */}
				<C.SocialMedia>
					<C.InstagramLink
						onClick={() =>
						(window.location.href =
							"https://www.instagram.com/rotta_pizzariadelivery/profilecard/?igsh=ZTd1NDd0amw1MTN2")
						}
					>
						<C.SocialMediaIcon src={InstagramIcon} alt="Logo do Instagram" />
						<C.SocialMediaInformation>Rota Pizzaria</C.SocialMediaInformation>
					</C.InstagramLink>

					<C.WhatsAppLink
						onClick={() => (window.location.href = "https://wa.me/5566999380118")}
					>
						<C.SocialMediaIcon src={WhatsAppIcon} alt="Logo do WhatsApp" />
						<C.SocialMediaInformation>(66) 999380118</C.SocialMediaInformation>
					</C.WhatsAppLink>
				</C.SocialMedia>

				{/* Filtro de categorias */}
				<C.SelectCategories
					id="pizzaCategory"
					name="pizzaCategory"
					value={categoriaSelecionada}
					onChange={(e) => setCategoriaSelecionada(e.target.value)}
				>
					<option value="all">Sem filtro</option>
					<option value="meioMetro">Pizzas Meio Metro</option>
					<option value="tradicionais">Pizzas Tradicionais</option>
					<option value="especiais">Pizzas Especiais</option>
					<option value="doces">Pizzas Doces</option>
					<option value="combos">Combos de Pizzas</option>
				</C.SelectCategories>

				{/* Lista de pizzas */}
				<C.PizzaSection>
					{Object.entries(pizzasFiltradas).map(([categoria, listaDePizzas]) => {
						if (listaDePizzas.length === 0) return null;

						return (
							<div key={categoria}>
								<C.PizzaSectionTitle>
									{categoria !== "combo" ? `Pizzas ${categoria.charAt(0).toUpperCase() + categoria.slice(1)}`.toUpperCase() : 'COMBOS'}
								</C.PizzaSectionTitle>
								<ul>
									{listaDePizzas.map((pizza, index) => (
										<li key={index}>
											<Card
												onClick={() => handleOrder(pizza)}
												pizza={pizza}
												index={index + 1}
											/>
										</li>
									))}
								</ul>
							</div>
						);
					})}
				</C.PizzaSection>

				{/* Refrigerantes */}
				<div key={"refrigerantes"}>
					<C.PizzaSectionTitle>Refrigerantes</C.PizzaSectionTitle>
					<ul>
						{pizzas.refrigerantes.map((refri, index) => (
							<li key={index}>
								<C.CardRefrigerator pizza={refri} index={index + 1}>
									<strong>{refri.nome} (R$ {refri.valor},00)</strong>
									<C.CardImage src={refri.nome === "Coca Cola 2L" ? Coca : Kitubaina} alt="Imagem do Refrigerante" />

									<C.ButtonGroup>
										<C.Button
											onClick={() => handleRemove(refri.nome, refri.valor)}
											action="remove"
										>
											-
										</C.Button>
										<C.CurrentRefriQtd>
											{currentOrder.refris && (currentOrder.refris.find((item) => item.name === refri.nome)?.quantity || 0)}
										</C.CurrentRefriQtd>
										<C.Button
											onClick={() => handleAdd(refri.nome, refri.valor)}
											action="add"
										>
											+
										</C.Button>
									</C.ButtonGroup>
								</C.CardRefrigerator>
							</li>
						))}
					</ul>
				</div>
			</C.HomeContent>

			{/* Footer */}
			<Footer />
		</C.HomeContainer>
	);
};

export default Home;